import Spinner from 'components/spinner/Spinner';
import TextFieldCustom from 'components/TextFieldCustom';
import { getBaseURL } from 'helpers';
import React, { useState } from 'react';
import { Modal } from 'react-bootstrap';


const QualitativeEditModal = ({ show, onHide, buttonText, buttonLoadingText, textFiledLabel, title, reloadData, id }) => {

    const [value, setValue] = useState();
    const [loading, setLoading] = useState(false);

    const handleOnClick = async () => {
        setLoading(true);
        id ? reloadData(id, value) : reloadData(value);
        onHide();
        setLoading(false);
    }

    return (
        <>

            <Modal show={show} size='size' centered={true}>
                <Modal.Header
                    className='p-4'
                    closeButton
                    onClick={() => onHide()}
                >
                    <h3>
                        {title}
                    </h3>
                </Modal.Header>
                <Modal.Body style={{
                    backgroundImage: `url(${getBaseURL("/assets/icons/Reset-Password.png")})`,
                    backgroundRepeat: 'no-repeat',
                    backgroundSize: '70%',
                    backgroundPosition: "19px"
                }} className='p-4 m-auto border-0 w-100'>
                    <div className='w-100'>
                        <div className='text-center w-100'>
                            <TextFieldCustom
                                label={textFiledLabel}
                                fullWidth
                                value={value}
                                onChange={(e) => setValue(e.target.value)}
                                size="small"
                                sx={{
                                    marginTop: "6px",
                                    marginBottom: "6px",
                                    backgroundColor: "white",
                                }}
                            />
                        </div>
                    </div>
                    <div className='d-flex justify-content-center py-5'>
                        <button
                            type='button'
                            className='btn btn-dark btn-bg-dark btn-sm'
                            onClick={() => {
                                handleOnClick();
                            }}
                        >
                        {
                            loading ? <Spinner message={buttonLoadingText} /> : buttonText
                        }
                        </button>
                    </div>
                </Modal.Body>
            </Modal>
        </>
    );
}

QualitativeEditModal.defaultProps = {
    show: false,
    buttonText: "Edit",
    buttonLoadingText: "Loading...",
    title: "Edit",
    textFiledLabel: '',
    id: null,
    reloadData: () => {},
};

export default QualitativeEditModal;